var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return !_vm.mobile
    ? _c(
        "v-card-title",
        { class: "bg-white p-3" },
        [
          _c(
            "v-container",
            {
              staticClass: "p-2",
              attrs: {
                fluid: "",
                "grid-list-lg": "",
                "fill-height": "",
                "text-xs-center": "",
              },
            },
            [
              _c(
                "v-layout",
                {
                  staticClass: "result-question p-0",
                  attrs: { row: "", wrap: "", "align-center": "" },
                },
                [
                  _c(
                    "v-flex",
                    {
                      staticClass: "text-sm-start",
                      attrs: { xs7: "", md8: "" },
                    },
                    [
                      _c("div", { staticClass: "title" }, [
                        _vm._v(_vm._s(_vm.skillItem.name)),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "caption" }, [
                        _vm._v(
                          "\n          " +
                            _vm._s(_vm.skillAverage) +
                            "% " +
                            _vm._s(
                              _vm.$t("exam_result.average", {
                                format: _vm.LETTER_FORMAT.UPTITLECASE,
                              })
                            ) +
                            "\n        "
                        ),
                      ]),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "v-flex",
                    {
                      staticClass: "text-xs-center",
                      attrs: { xs5: "", md4: "" },
                    },
                    [
                      _c("SlideBar", {
                        attrs: {
                          current: _vm.skillScore,
                          total: 100,
                          slideType: "col",
                          slideColor:
                            _vm.skillScore >= _vm.skillAverage
                              ? "#7DD420"
                              : "red",
                          maxSize: "100px",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      )
    : _c("v-layout", { class: "question-white-bgr p-3" }, [
        _c("table", { staticClass: "skill-full-width" }, [
          _c("tr", [
            _c("td", { staticClass: "skill-td-left" }, [
              _c("div", { staticClass: "title" }, [
                _vm._v(_vm._s(_vm.skillItem.name)),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "caption" }, [
                _vm._v(
                  "\n          " +
                    _vm._s(_vm.skillAverage) +
                    "% " +
                    _vm._s(
                      _vm.$t("exam_result.average", {
                        format: _vm.LETTER_FORMAT.UPTITLECASE,
                      })
                    ) +
                    "\n        "
                ),
              ]),
            ]),
            _vm._v(" "),
            _c(
              "td",
              { staticClass: "text-xs-right skill-td-right" },
              [
                _c("SlideBar", {
                  attrs: {
                    current: _vm.skillScore,
                    total: 100,
                    slideType: "col",
                    slideColor:
                      _vm.skillScore >= _vm.skillAverage ? "#7DD420" : "red",
                    maxSize: "100px",
                  },
                }),
              ],
              1
            ),
          ]),
        ]),
      ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }